(function () {
  const section = document.querySelector('[id^="section-"]');
  if (!section) return;

  const sectionId = section.id.replace('section-', '');
  const openFilterBtn = document.getElementById(`openFilterPanel-${sectionId}`);
  const closeFilterBtn = document.getElementById(`closeFilterPanel-${sectionId}`);
  const filterPanel = document.getElementById(`filterPanel-${sectionId}`);
  const filterOverlay = document.getElementById(`filterPanelOverlay-${sectionId}`);
  const applyBtn = document.getElementById(`applyFilters-${sectionId}`);

  // Mobile filter panel open/close
  if (openFilterBtn && closeFilterBtn && filterPanel && filterOverlay) {
    function openPanel() {
      filterPanel.classList.add('active');
      filterOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closePanel() {
      filterPanel.classList.remove('active');
      filterOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    openFilterBtn.addEventListener('click', openPanel);
    closeFilterBtn.addEventListener('click', closePanel);
    filterOverlay.addEventListener('click', closePanel);
  }

  // Filter group collapse/expand
  document.querySelectorAll('[data-filter-toggle]').forEach(function (header) {
    header.addEventListener('click', function () {
      this.closest('.filter-group').classList.toggle('collapsed');
    });
  });

  // Sort selects — navigate preserving existing URL params
  document.querySelectorAll('.sort-select, .mobile-sort-select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', this.value);
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });

  // Desktop filter option click — navigate immediately
  document.querySelectorAll('.filters-sidebar .filter-option[data-filter-url]').forEach(function (option) {
    option.addEventListener('click', function () {
      var url = this.getAttribute('data-filter-url');
      if (url) window.location.href = url;
    });
  });

  // Mobile filter option click — toggle visual state only, no navigation
  if (filterPanel) {
    filterPanel.querySelectorAll('.filter-option').forEach(function (option) {
      option.addEventListener('click', function () {
        this.classList.toggle('active');
      });
    });
  }

  // Price range — desktop only, apply on Enter or Apply button
  function applyPriceFilter(container) {
    var minInput = container.querySelector('[name="filter.v.price.gte"]');
    var maxInput = container.querySelector('[name="filter.v.price.lte"]');
    var params = new URLSearchParams(window.location.search);
    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');
    params.delete('page');
    if (minInput && minInput.value !== '') params.set('filter.v.price.gte', minInput.value);
    if (maxInput && maxInput.value !== '') params.set('filter.v.price.lte', maxInput.value);
    window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  }

  document.querySelectorAll('.filters-sidebar [data-filter-price]').forEach(function (container) {
    container.querySelectorAll('.price-input').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') applyPriceFilter(container);
      });
    });
    var priceApplyBtn = container.querySelector('[data-price-apply]');
    if (priceApplyBtn) priceApplyBtn.addEventListener('click', function () { applyPriceFilter(container); });
  });

  // Clear all filters
  document.querySelectorAll('.filter-clear, #clearAllFilters-' + sectionId).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(window.location.search);
      Array.from(params.keys()).forEach(function (key) {
        if (key.startsWith('filter.')) params.delete(key);
      });
      params.delete('page');
      window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    });
  });

  // Mobile Apply button — collect all toggled filter options + price range, navigate once
  if (applyBtn && filterPanel) {
    applyBtn.addEventListener('click', function () {
      var params = new URLSearchParams(window.location.search);
      Array.from(params.keys()).forEach(function (key) {
        if (key.startsWith('filter.')) params.delete(key);
      });
      params.delete('page');

      filterPanel.querySelectorAll('.filter-option[data-filter-param].active').forEach(function (option) {
        params.append(option.getAttribute('data-filter-param'), option.getAttribute('data-filter-value'));
      });

      var minInput = filterPanel.querySelector('[name="filter.v.price.gte"]');
      var maxInput = filterPanel.querySelector('[name="filter.v.price.lte"]');
      if (minInput && minInput.value !== '') params.set('filter.v.price.gte', minInput.value);
      if (maxInput && maxInput.value !== '') params.set('filter.v.price.lte', maxInput.value);

      window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    });
  }

  // Highlight filter groups that have pre-applied filters (from navbar deep-links)
  // Pulses the entire filter group if any of its options are active on page load
  (function highlightActiveFilterGroups() {
    var params = new URLSearchParams(window.location.search);
    var hasFilterParam = Array.from(params.keys()).some(function (k) { return k.startsWith('filter.'); });
    if (!hasFilterParam) return;

    var activeGroups = [];
    document.querySelectorAll('.filters-sidebar .filter-group').forEach(function (group) {
      if (group.querySelector('.filter-option.active')) {
        activeGroups.push(group);
      }
    });

    if (activeGroups.length === 0) return;

    activeGroups.forEach(function (group) {
      group.classList.add('filter-group--highlight');
      setTimeout(function () { group.classList.remove('filter-group--highlight'); }, 2000);
    });

    // Scroll sidebar to first highlighted group
    var firstGroup = activeGroups[0];
    setTimeout(function () {
      firstGroup.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  })();

  // Add to Cart — AJAX, no redirect
  document.querySelectorAll('.product-quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      var self = this;
      var originalText = self.textContent;
      self.disabled = true;
      self.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
          return res.json();
        })
        .then(function () {
          self.textContent = 'Added!';
          updateCartCount();
          setTimeout(function () {
            self.textContent = originalText;
            self.disabled = false;
          }, 2000);
        })
        .catch(function () {
          self.textContent = 'Error';
          setTimeout(function () {
            self.textContent = originalText;
            self.disabled = false;
          }, 2500);
        });
    });
  });

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

})();
